<div class="error container">
  <div class="error__content">
    <h1>Page not found</h1>
  </div>
</div>
